import { pushApp, initializePushApp } from './firebasePushInit'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'

let messaging = null
let messagingReady: Promise<void> | null = null
const vapid = import.meta.env.VITE_PUSH_PUBLIC_API_KEY

const initMessagingSafe = async (): Promise<void> => {
  try {
    const supported = await isSupported()
    if (supported) {
      initializePushApp()
      messaging = getMessaging(pushApp)
    }
  } catch (err) {
    console.warn('Firebase Messaging is not supported in this browser.', err)
  }
}

const ensureInitialized = (): Promise<void> => {
  if (!messagingReady) {
    messagingReady = initMessagingSafe()
  }
  return messagingReady
}

export const getMessagingToken = async (): Promise<string> => {
  try {
    await ensureInitialized()
    if (!messaging) return ''
    const currentToken = await getToken(messaging, {
      vapidKey: vapid
    })
    if (currentToken) {
      return currentToken
    } else {
      console.error('No registration token available. Request permission to generate one.')
      return ''
    }
  } catch (err) {
    console.error('An error occurred while retrieving token. ', err)
    return ''
  }
}
export const onMessageListener = (executeOnMessage: (payload: any) => void) => {
  ensureInitialized().then(() => {
    if (messaging) {
      onMessage(messaging, async (message) => {
        try {
          const payload = JSON.parse(message.data.payload)
          executeOnMessage(payload)
        } catch (error) {
          console.error(error)
        }
      })
    }
  })
}
